import React from "react";
import { Helmet } from "react-helmet-async";
import { HreflangTags } from "../components/SeoHreflang";
import { Container, Typography, Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Helmet>
        <title>Page Not Found — Dr.Paw</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Dr.Paw to continue your veterinary education." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <HreflangTags />
      <Box sx={{ py: 8, textAlign: "center" }}>
        <Typography variant="h2" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Page not found
        </Typography>
        <Button variant="contained" component={RouterLink} to="/">
          Go home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
